import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { map } from "rxjs/operators";
import { BehaviorSubject, Observable } from 'rxjs';
import { AppConstant } from 'src/app/app.constant';
import { DataResult } from '@progress/kendo-data-query';

@Injectable({
  providedIn: 'root'
})
export class OpinionPollsService {

  apiUrl: string;

  constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
    this.apiUrl = this.appConstant.getUrl();
  }
  manageOpinionPoll(opinionPoll) {
    return this.httpClient.post(`${this.apiUrl}/manageOpinionPoll`, opinionPoll).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  getAllOpinionPoll(): Observable<DataResult> {
    return this.httpClient.get(`${this.apiUrl}/getAllOpinionPoll/`).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>;
  }
  getAllOpinionPollForUser(): Observable<DataResult> {
    return this.httpClient.get(`${this.apiUrl}/getAllOpinionPollForUser/`).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>;
  }
  getOpinionPollById(Id: number) {
    return this.httpClient.get(`${this.apiUrl}/getOpinionPollById/` + Id).pipe(
      map((response: any) => {
        return response.data;
      })
    )
  }
  giveOpinionByUser(opinionPoll) {
    return this.httpClient.post(`${this.apiUrl}/giveOpinionByUser`, opinionPoll).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  getAllUserOpinionByPollId(Id: number) {
    return this.httpClient.get(`${this.apiUrl}/getAllUserOpinionByPollId/` + Id).pipe(
      map((response: any) => {
        return response.data;
      })
    )
  }
}
